var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { ConnectedRouter } from "react-router-redux";
import "animate.css";
import store, { history } from "./store";
// import registerServiceWorker from './registerServiceWorker';
import App from "./containers/app";
import rootSaga from "./rootSaga";
import "./assets/css/index.scss";
import LocaleProvider from "./LocaleProvider.jsx";
require("./intl-polyfill");
store.runSaga(rootSaga);
ReactDOM.render(_jsx(Provider, __assign({ store: store }, { children: _jsx(LocaleProvider, { children: _jsx(ConnectedRouter, __assign({ history: history }, { children: _jsx(App, {}) })) }) })), document.getElementById("root"));



// WEBPACK FOOTER //
// ./src/index.js